import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import { store } from '@/store/index';
import App from './App';
import React from 'react';
const root = createRoot(document.getElementById('root'));
root.render(React.createElement(Provider, { store: store },
    React.createElement(App, null)));
